// src/components/Tutorial/Examples/CreatorsBrowser.js
import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import '../Tutorial.css';

const CreatorsBrowser = ({ isMobile }) => {
  const allCreators = [
    {
      name: 'Sierra',
      rating: 4.2,
      reviews: 8,
      avgSpend: '$45.00',
      recommend: '85%',
      emoji: '👩‍🦰'
    },
    {
      name: 'Sophie Rain',
      rating: 4.6,
      reviews: 12,
      avgSpend: '$62.00',
      recommend: '92%',
      emoji: '👱‍♀️'
    }
  ];

  // Show only 1 creator on mobile, 2 on desktop
  const creators = isMobile ? allCreators.slice(0, 1) : allCreators;

  return (
    <Box className="example-container">
      <Paper elevation={3} className="tutorial-paper-extra-wide">
        <Typography variant="h6" gutterBottom textAlign="center">
          Discover Top Creators
        </Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 3 }}>
          Browse and filter through our curated list of creators, rated by real subscribers.
        </Typography>
        
        <div className="tutorial-creator-grid">
          {creators.map((creator, index) => (
            <Paper 
              key={index}
              elevation={2}
              className="tutorial-creator-card"
            >
              <div className="tutorial-creator-avatar emoji-bounce">
                {creator.emoji}
              </div>
              <Typography variant="subtitle1" fontWeight={600}>{creator.name}</Typography>
              <Typography variant="body2" color="text.secondary">
                Rating: ⭐ {creator.rating}/5
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Reviews: {creator.reviews}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Avg Spend: {creator.avgSpend}
              </Typography>
              <Button variant="contained" size="small" sx={{ mt: 1 }}>
                View Profile
              </Button>
            </Paper>
          ))}
        </div>
      </Paper>
    </Box>
  );
};

export default CreatorsBrowser;
